import React, { ReactNode } from 'react';
import classNames from 'classnames';
import ClockIcon from '@moda/icons/clock-20';
import { SECONDS_TO_MILLISECONDS, useTimer } from '@moda/portal-stanchions';

import './TrunkshowCountdownTimer.scss';

interface Props {
  countdownTime: number;
  countdownEndMessage?: ReactNode;
  endingText?: string;
  hasZeroes?: boolean;
  hasIcon?: boolean;
  className?: string;
  largeIcon?: boolean;
}

export const SHOW_TIMER_UPPER_BOUND_IN_DAYS = 40;
const ENDING_SOON_LOWER_BOUND_IN_DAYS = 3;

export const TrunkshowCountdownTimer: React.FC<Props> = ({
  endingText = 'Ends in',
  hasZeroes = false,
  countdownTime,
  countdownEndMessage = 'Trunkshow ended',
  hasIcon,
  className,
  largeIcon
}) => {
  //rubydate.time.to_i returns seconds from epoch, we want milliseconds
  const [timeLeft] = useTimer(countdownTime * SECONDS_TO_MILLISECONDS, hasZeroes);

  const showTimer = parseInt(timeLeft.totalDaysLeft, 10) < SHOW_TIMER_UPPER_BOUND_IN_DAYS;

  if (!showTimer) return null;

  return (
    <div className={className}>
      {hasIcon && (
        <ClockIcon
          aria-label="Countdown Timer"
          role="img"
          className={classNames('TrunkshowCountdownTimer__icon', {
            'TrunkshowCountdownTimer__icon-large': largeIcon === true
          })}
        />
      )}
      <div
        className={classNames('TrunkshowCountdownTimer', {
          'TrunkshowCountdownTimer--ending-soon':
            parseInt(timeLeft.totalDaysLeft, 10) <= ENDING_SOON_LOWER_BOUND_IN_DAYS
        })}
      >
        {timeLeft.isOver && countdownEndMessage}
        {!timeLeft.isOver && (
          <>
            {endingText}
            {timeLeft.monthsLeft != '0' && (
              <span className="TrunkshowCountdownTimer__digit"> {timeLeft.monthsLeft + 'mo'} </span>
            )}
            <span className="TrunkshowCountdownTimer__digit"> {timeLeft.daysLeft + 'd'} </span>
            <span className="TrunkshowCountdownTimer__digit"> {timeLeft.hoursLeft + 'h'} </span>
            <span className="TrunkshowCountdownTimer__digit"> {timeLeft.minutesLeft + 'm'} </span>
          </>
        )}
      </div>
    </div>
  );
};
